export default __webpack_public_path__ + "static/media/IBMChevronLeft.5e652be6.svg";